import logo1999 from "../../assets/img/historicEvents/LogoArmageddon/1999.png";
import logo2000 from "../../assets/img/historicEvents/LogoArmageddon/2000.png";
import logo2002_2003 from "../../assets/img/historicEvents/LogoArmageddon/2002-2003.png";
import logo2004 from "../../assets/img/historicEvents/LogoArmageddon/2004.png";
import logo2005_2007 from "../../assets/img/historicEvents/LogoArmageddon/2005-2007.png";
import logo2008 from "../../assets/img/historicEvents/LogoArmageddon/2008.png";

export const armageddonDetail = {
  armageddon: {
    id: "armageddon",
    title: "Armageddon",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "armageddon",
        items: [
          {
            id: "armageddon-1999",
            title: "Armageddon",
            description: "The End Is Here 1999",
            imgUrl: logo1999,
          },
          {
            id: "armageddon-2000",
            title: "Armageddon",
            description: "Lord, I'm Coming Home to You. 2000",
            imgUrl: logo2000,
          },
          {
            id: "armageddon-2002",
            title: "Armageddon",
            description: "2002",
            imgUrl: logo2002_2003,
          },
          {
            id: "armageddon-2003",
            title: "Armageddon",
            description: "Evolution of The Game 2003",
            imgUrl: logo2002_2003,
          },
          {
            id: "armageddon-2004",
            title: "Armageddon",
            description: "2004",
            imgUrl: logo2004,
          },
          {
            id: "armageddon-2005",
            title: "Armageddon",
            description: "2005",
            imgUrl: logo2005_2007,
          },
          {
            id: "armageddon-2006",
            title: "Armageddon",
            description: "The End... Is Only the Beginning 2006",
            imgUrl: logo2005_2007,
          },
          {
            id: "armageddon-2007",
            title: "Armageddon",
            description: "The Most Devastating Wars Are Fought Over Championship Gold. 2007",
            imgUrl: logo2005_2007,
          },
          {
            id: "armageddon-2008",
            title: "Armageddon",
            description: "2008",
            imgUrl: logo2008,
          },
        ],
      },
    ],
  },
};
